import { render } from "./InvoiceRegistrationList.vue?vue&type=template&id=3236b645"
import script from "./InvoiceRegistrationList.vue?vue&type=script&lang=js"
export * from "./InvoiceRegistrationList.vue?vue&type=script&lang=js"

import "./InvoiceRegistrationList.vue?vue&type=style&index=0&id=3236b645&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__